import React from 'react';

import { useInvestorProfileActivityQuery } from 'generated/graphql';
import _ from 'lodash';
import {
  formatUtil,
  useLoading
} from 'modules';



export function useInvestorProfileActivity(userId: string) {
  const tuple = useInvestorProfileActivityQuery({
    variables: {
      userId
    }
  });
  const loading = useLoading([tuple]);



  return React.useMemo(() => {
    const companyProfile = tuple.data?.user?.companyProfile;
    const investorProfile = tuple.data?.user?.investorProfile;

    return ({
      loading,
      refetch: tuple.refetch,
      data: {
        isFavorited: _.some(tuple.data?.favoritedInvestors, investor => investor.id === userId),
        companyName: companyProfile?.name ?? '',
        profilePictureKey: companyProfile?.logo?.key ?? '',
        investmentCategory: companyProfile?.investmentCategory?.displayName ?? '',
        description: companyProfile?.description,
        websiteUrl: companyProfile?.websiteUrl || 'N/A',
        address: _.compact([
          companyProfile?.address.city,
          companyProfile?.address.usState,
          companyProfile?.address.country
        ]).join(', ') || 'N/A',
        canLeadInvestments: investorProfile?.canLeadInvestments ? 'Yes' : 'No',
        isVerifiedInvestor: investorProfile?.isVerifiedInvestor ?? false,
        checkSizeMinDollars: formatUtil.getDollarString(investorProfile?.checkSizeMinDollars),
        checkSizeMaxDollars: formatUtil.getDollarString(investorProfile?.checkSizeMaxDollars),

        investmentStages: _.map(companyProfile?.investmentStages, stage => stage.displayName),
        investmentAreas: _.map(companyProfile?.investmentAreas, area => area.displayName),
        investmentGeographies: _.map(companyProfile?.investmentGeographies, geography => geography.displayName)
      }
    });
  }, [loading, tuple, userId]);
}
